export { default as LazyTippy } from './LazyTippy';
